<template>
  <div class="relative">
    <slot name="visible" />
    <div
      class="absolute left-0 w-full transition"
      :class="{
        'opacity-0 pointer-events-none': !modelValue,
        'bottom-full': position === 'top',
        'top-full': position === 'bottom',
      }"
    >
      <slot name="overlay" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean;
  position: "top" | "bottom";
}>();
</script>
